import Marionette from "backbone.marionette";

export default Backbone.Collection.extend({
    url: "api/reports/index.php",
    //Overwrite behaviour for Hal+JSON data
    parse: function (data) {
        this.pageAttributes = {
            page: data.page,
            page_count: data.page_count,
            page_size: data.page_size,
            total_items: data.total_items
        };

        this.lang = data.lang;
        this.desc = data.desc;
        this.fieldsfilter = data.fieldsFilter;

        return data._embedded;
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/collections/reportCollection.js
// module id = 167
// module chunks = 0